import React, { useEffect } from 'react';
import { components } from 'react-select';

export const ValueContainer = props => {

 
  return (
    <div className="">
      <components.ValueContainer {...props}>
       <label className='mx-1'>{props.getValue().length} seleccionadas</label>
      </components.ValueContainer>
    </div>
  );
};
